<template>
  <div class="container containerManage mt10 ml10 mr10">
    <div v-if='isinfo'>
      <div class="handle-box mt10">
        <div style="margin-bottom:15px">
          <span class="fz14 c6">{{ $t('manipulation.devName') }}：</span>
          <el-select v-model="projectName" clearable :placeholder="$t('dataAnalysis.pleCho')" style="width:220px">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.projectName"
              :value="item.projectName">
            </el-option>
          </el-select>
          <span class="fz14 c6 ml10 ">{{ $t('fileManage.areaName') }}：</span>
          <el-cascader v-model="province" clearable :placeholder="$t('fileManage.pleChoArea')"
            style="width:220px;margin: 0 5px;" :options="cityList" :props='props' filterable>
          </el-cascader>
          <span class="fz14 c6 ml10 ">{{ $t('manipulation.elevatorBrand') }}：</span>
          <el-select v-model="elevatorBrand" clearable :placeholder="$t('dataAnalysis.pleCho')" style="width:220px">
            <el-option v-for="(item, index) in typeList1" :key="index" :label="item.dictValue" :value="item.dictKey">
            </el-option>
          </el-select>
        </div>
        <div>
          <span class="fz14 c6">{{ $t('manipulation.installAddress') }}：</span>
          <el-input v-model.trim="address" clearable placeholder="" class="handle-input "
            style="width:220px"></el-input>
          <span class="fz14 c6 ml20 ">{{ $t('manipulation.airNum') }}：</span>
          <el-input v-model.trim="devNumber" clearable placeholder="" class="handle-input "
            style="width:220px"></el-input>
          <el-button type="primary" size="small" class="ml10" icon="el-icon-search"
            @click="getprojectPage">{{ $t('tagsView.search') }}</el-button>
          <el-button type="primary" size="small" class="ml10" icon="el-icon-search"
            @click="result">{{ $t('dataAnalysis.reset') }}</el-button>
          <el-button type="primary" size="small" class=" ml10" v-if="permission.sys_project_add"
            icon="el-icon-circle-plus-outline" @click="addHandle">{{ $t('fileManage.add') }}</el-button>
        </div>

      </div>
      <div class="tableData">
        <el-table :data="tableData" border class="table" style="width: 100%;" ref="multipleTable"
          header-cell-class-name="table-header">
          <el-table-column :label="$t('realdetile.serNum')" align="center">
            <template slot-scope="scope">
              {{ scope.row.index }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('manipulation.devName')" align="center">
            <template slot-scope="scope">
              {{ scope.row.projectName }}<div @click='hisinfo(scope.row)' v-if='scope.row.projectNameCount > 1'
                style="color:#0694ec;font-size:12px">{{ $t('fileManage.lookHisRevise') }}</div>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index) in column" align="center" :prop='item.prop' :label="item.label"
            :width="item.width" :key="index"> </el-table-column>
          <el-table-column :label="$t('realdetile.opera')" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" v-if="permission.sys_project_detail"
                @click="viewHandle(scope.row)">{{ $t('fileManage.viewDetail') }}</el-button>

            </template>
          </el-table-column>
          <el-table-column :label="$t('realdetile.opera')" width="270" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" @click="editchange(scope.row)"
                v-if="scope.row.status == 0">{{ $t('fileManage.handoff') }}</el-button>
              <el-button type="text" icon="el-icon-edit" v-if="permission.sys_project_edit"
                @click="editHandle(scope.row)">{{ $t('alarmSetting.edit') }}</el-button>
              <el-button type="text" icon="el-icon-delete" v-if="permission.sys_project_del" class="red"
                @click="deleteHandle(scope.row)">{{ $t('alarmSetting.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="text-align:end;margin:12px 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="page.current" :page-size="page.size"
            layout="total, prev, pager, next" :total="totals">
          </el-pagination>
        </div>
      </div>
      <FileModel :DialogVisible="DialogVisible" :dialogType='dialogType' @closefile="closefile" ref="filemodel" />
      <el-dialog :title="$t('fileManage.insHisNameRevise')" :visible.sync="hisVisible" width="50%">
        <div>
          <el-table :data="tableData1" border class="table" style="width: 100%;" ref="multipleTable"
            header-cell-class-name="table-header">

            <el-table-column v-for="(item, index) in column1" :prop='item.prop' :label="item.label" :width="item.width"
              :key="index"> </el-table-column>

          </el-table>
        </div>
        <div slot="footer" class="dialog-footer flex row vertical-center">

        </div>
      </el-dialog>
    </div>

    <div v-if="!isinfo">
      <Fileinfo @goblack='goblack' ref="fileinfo1" />
    </div>
  </div>

</template>

<script>

import { projectPage, deleteproject, dictList, projectList, getProjectNameListById, updateStatus } from '@/api/deviceOverview/file';
import { getLazyTree } from '@/api/base/region';

import { mapGetters } from 'vuex';
import FileModel from './filemodel'
import Fileinfo from './fileInfo'
export default {
  name: 'fileManage',
  components: {
    FileModel, Fileinfo
  },
  data() {
    return {
      hisVisible: false,
      isinfo: true,
      currentPage: 1,
      totals: 0,
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 10
      },
      column: [

        { prop: 'address', label: this.$t('manipulation.installAddress') },
        { prop: 'deviceCount', label: this.$t('manipulation.insNum') },
        { prop: 'organization', label: this.$t('realdetile.contUnit') },
        { prop: 'installDate', label: this.$t('fileManage.timeSetting') },
        { prop: 'status1', label: this.$t('realdetile.projectStatus') },
      ],
      DialogVisible: false,
      dialogType: this.$t('userManage.newAdd'),
      tableData: [],
      deviceNoInput: '',
      sawModelInput: '',
      typeList: [],
      typeList1: [],
      deviceStatus: '',
      projectName: '',
      address: '',
      elevatorBrand: '',
      devNumber: '',
      page: {
        current: 1,
        size: 10
      },
      column1: [
        { prop: 'index', label: this.$t('realdetile.serNum') },
        { prop: 'projectName', label: this.$t('manipulation.devName') },
        { prop: 'installAddress', label: this.$t('manipulation.installAddress') },
        { prop: 'createUserName', label: this.$t('fileManage.chaAccount') },
        { prop: 'createTime', label: this.$t('fileManage.updateTime') },

      ],
      tableData1: [],
      cityList: [],
      province: [],
      props: {
        label: 'title',
        value: 'title'
      },
    };
  },
  computed: {
    ...mapGetters(['permission'])
  },
  created() {

    this.getLazyTree()
    this.getdictList()
    console.log(this.$route.query.id)

  },
  mounted() {

  },
  methods: {
    // 获取省市
    getLazyTree() {
      getLazyTree().then(res => {
        if (res.data.code == 200) {

          this.cityList = res.data.data
        }
      })
    },
    getProjectNameListById(info) {
      getProjectNameListById({ id: info.id }).then(res => {
        if (res.data.code === 200) {
          res.data.data.map((item, index) => {
            item.index = index + 1
          })
          this.tableData1 = res.data.data
        }
      })
    },
    hisinfo(info) {
      this.getProjectNameListById(info)
      this.hisVisible = true
    },
    getdictList() {
      projectList().then(res => {
        if (res.data.code === 200) {
          this.typeList = res.data.data
          if (this.$route.query.id) {
            this.projectName = this.$route.query.id
          }
          this.getprojectPage()
        }
      })
      // 电梯
      dictList({ code: "elevator_brand" }).then(res => {
        if (res.data.code === 200) {
          this.typeList1 = res.data.data[0].children
        }
      })
    },
    result() {
      this.projectName = ''
      this.address = ''
      this.elevatorBrand = ''
      this.devNumber = ''
      this.province = []
      this.page.current = 1
      this.getprojectPage()
    },
    getprojectPage() {
      let obj = {
        projectName: this.projectName,
        address: this.address,
        city: this.province[1],
        elevatorBrand: this.elevatorBrand,
        devNumber: this.devNumber,
        type: 'projectDetail',
        ...this.page
      }
      projectPage(obj).then(res => {

        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
            item.status == 0 ? item.status1 = this.$t('fileManage.debug') : (item.status == 1 ? item.status1 = this.$t('fileManage.set') : '')
          })
          this.tableData = res.data.data.records
          this.page.current = res.data.data.current
          this.totals = res.data.data.total
        }
      })
    },
    handleCurrentChange(e) {
      this.page.current = e
       this.getprojectPage()
    },
    //详情
    viewHandle(info) {
      this.isinfo = false
      setTimeout(() => {
        this.$refs.fileinfo1.getprojectDeviceList(info)
      }, 0);
    },
    goblack() {
      this.isinfo = true
    },
    addHandle() {
      this.dialogType = this.$t('userManage.newAdd')
      this.DialogVisible = true
      this.$refs.filemodel.mapselectpoint()
    },
    editHandle(info) {
      this.dialogType = this.$t('roleManage.revise')
      this.DialogVisible = true

      this.$refs.filemodel.mapselectpoint()
      this.$refs.filemodel.getinfo(info)
    },
    deleteHandle(info) {
      this.$confirm(this.$t('fileManage.infoback'), this.$t('export default.tip'), {
        confirmButtonText: this.$t('manipulation.sure'),
        cancelButtonText: this.$t('manipulation.cancel'),
        type: 'warning'
      }).then(() => {
        deleteproject({ ids: info.id }).then(res => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg)
            this.getprojectPage()
          }
        })
      }).catch(() => { });

    },
    closefile(num) {
      this.DialogVisible = false
      if (num) {
        this.getprojectPage()
      }
    },
    editchange(val) {

      let obj = {
        id: val.id,
        status: '1'
      }
      updateStatus(obj).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg)
          this.getprojectPage()
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.containerManage {
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);

  .handle-box {
    margin-bottom: 20px;
  }
}

.authForm {
  .el-tree {
    height: 500px;
    overflow: auto;
  }

}
</style>
